// extracted by mini-css-extract-plugin
export default {"avatar":"avatar___iy3hW","username":"username___dHL3z","dropdown-arrow":"dropdown-arrow___EwGvq","expand-icon":"expand-icon____VLsT","tag":"tag___COMio","bell":"bell___IqOE5"};